import { Container, Row, Col, Tab, Nav, Modal } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { useState } from "react";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import Jinder from "../assets/img/jinder.png";
import CMS from "../assets/img/CMS-app.png";
import portfolio from "../assets/img/portfolio.png";
import sanofi from "../assets/img/sanofi.png";
/* TabContainer allows for more complex layouts
    TabContent and TabPane components along with Nav allows you to piece together your own tabs with additional markup
    as needed.
    
    Creating a set of navitems with an eventkey that corresponds to the eventkey of tabpane
    
    Wrapping it all in tabcontainer gives you fully functioning custom tabs component.*/

const projects = [
  {
    title: "Genealogy App",
    description: "Dynamic Data Explorer",
    imgUrl: sanofi,
    skills: ["Snowflake", "SQL", "Pandas", "Python", "Streamlit"],
    details: [
      {
        title: "About",
        text: "I developed a custom application within the Snowflake ecosystem specifically for Sanofi employees. The goal was to solve a recurring challenge: other departments frequently relied on our data team to manually query information. I designed a user-friendly interface featuring advanced filtering logic that allows non-technical users to independently generate relevant data tables and dynamic graphs.",
      },
      {
        title: "Development",
        text: "The project began with a legacy Jupyter Notebook. My task was to reverse-engineer the existing logic, understand the underlying data structures, and translate that functionality into a scalable application. This required me to learn new programming languages and frameworks on the fly, transitioning a manual script into a robust, automated tool with a focus on UI/UX.",
      },
      {
        title: "Outcome",
        text: "The application is currently slated for release to multiple departments across Sanofi. By transitioning from a manual query process to this streamlined, automated system, the project significantly reduces the 'ad-hoc' workload for our data engineers, allowing the team to focus on high-level architecture.",
      },
      {
        title: "Reflection",
        text: "Through this experience, I’ve gained technical proficiency in new languages and a deep understanding of how global companies develop and deploy code. Beyond the technical aspect, I learned the importance of professional presentation and cross-team collaboration.",
      },
    ],
  },
  {
    title: "Jinder",
    description: "Job Search Platform",
    imgUrl: Jinder,
    skills: ["React", "Typescript", "SQL"],
  },
  {
    title: "University Faculty Management Application",
    description: "Android Application",
    imgUrl: CMS,
    skills: ["React", "Typescript", "SQL"],
  },
  {
    title: "Portfolio Website",
    description: "Design & Development",
    imgUrl: portfolio,
    skills: ["React", "Typescript", "SQL"],
  },
];
export const Projects = () => {
  // holds the objects that we want to display

  const [selectedProject, setSelectedProject] = useState(null);
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {/* from the anime module */}
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__bounceIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Below is a collection of projects I’ve built. Each one
                    helped me learn something new and sharpen my skills.
                  </p>
                </div>
              )}
            </TrackVisibility>
            <Tab.Container id="projects-tab" defaultActiveKey="first">
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center align-items0center"
                id="pills-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">Tab 1</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Tab 2</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Tab 3</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Row>
                    {/* place all the project cards */}
                    {projects.map((project, index) => {
                      // the ...project means the rest of the props
                      return (
                        <ProjectCard
                          key={index}
                          {...project}
                          onClick={() => {
                            setSelectedProject(project);
                          }}
                        />
                      );
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="second">Loren Ipsum</Tab.Pane>
                <Tab.Pane eventKey="third">Loren Ipsum</Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
      <Modal
        show={selectedProject !== null}
        onHide={() => setSelectedProject(null)}
        centered
        size="xl"
        className="project-modal"
      >
        <Modal.Body className="p-0">
          {" "}
          {/* Remove padding for flush image */}
          <Container fluid className="p-0">
            <Row className="g-0">
              {/* Left Column */}
              <Col md={7} className="project-modal-visual">
                <img
                  src={selectedProject?.imgUrl}
                  alt="Project"
                  className="modal-main-img"
                />
              </Col>
              {/* Right Column */}
              <Col md={5} className="project-modal-info">
                <button
                  className="custom-close-btn"
                  onClick={() => setSelectedProject(null)}
                >
                  &times;
                </button>

                <div className="info-content">
                  <h2 className="modal-title-text">{selectedProject?.title}</h2>
                  <span className="modal-subtitle">
                    {selectedProject?.description}
                  </span>

                  <div className="skills-tag-container">
                    {selectedProject?.skills?.map((skill, index) => (
                      <span key={index} className="skill-tag">
                        {skill}
                      </span>
                    ))}
                  </div>

                  <hr className="modal-divider" />

                  {/* Loop through the details array */}
                  <div className="modal-scrollable-details">
                    {Array.isArray(selectedProject?.details) ? (
                      selectedProject.details.map((section, index) => (
                        <div key={index} className="modal-detail-section">
                          <h5 className="modal-section-title">
                            {section.title}
                          </h5>
                          <p className="modal-description-text">
                            {section.text}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p className="modal-description-text">
                        {selectedProject?.details ||
                          "Project details coming soon."}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
      {/* just the gradient */}
      <img
        src={colorSharp2}
        alt="colour sharp 2"
        className="background-image-right"
      />
    </section>
  );
};
